import { render, staticRenderFns } from "./Cmh.vue?vue&type=template&id=28f3e774"
import script from "./Cmh.vue?vue&type=script&lang=js"
export * from "./Cmh.vue?vue&type=script&lang=js"
import style0 from "./Cmh.vue?vue&type=style&index=0&id=28f3e774&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports